export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_FETCH = 'USER_FETCH';
export const USER_UPDATE = 'USER_UPDATE';
export const USER_INFO = 'USER_INFO';

export const SOCKET_CONNECT = 'SOCKET_CONNECT';
export const SOCKET_RECONNECT = 'SOCKET_RECONNECT';
export const SOCKET_DISCONNECT = 'SOCKET_DISCONNECT';
export const SOCKET_ERROR = 'SOCKET_ERROR';
export const SOCKET_START = 'SOCKET_START';
export const SOCKET_INIT = 'SOCKET_INIT';
export const SOCKET_RECV = 'SOCKET_RECV';
export const SOCKET_SEND = 'SOCKET_SEND';
export const SOCKET_LOGOUT = 'SOCKET_LOGOUT';
export const SOCKET_REGISTER = 'SOCKET_REGISTER';
export const SOCKET_MSG = 'SOCKET_MSG';
export const MESSAGE_RECENT_CONTACT = 'MESSAGE_RECENT_CONTACT';
export const MESSAGE_FETCH = 'MESSAGE_FETCH';

export const SCHOOL_SET = 'SCHOOL_SET';
export const SCHOOL_LIST = 'SCHOOL_LIST';

export const STYLE_WIDE_SET = 'STYLE_WIDE_SET';

export const TYPES_SET = 'TYPES_SET';



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js